module.exports = __webpack_public_path__ + "static/media/14_l_lystra_18.39_0.17fb5c40.png";